import { TooltipHost } from "@fluentui/react";
import { InfoIcon } from "@fluentui/react-icons-mdl2";
import { CustomCurrencyFormat } from "../../../utils/CustomCurrencyFormat";


interface IInterestData
{
    liquidationDaysOnSells: string,
    liquidationDaysOnBuys: string,
    ogc: number,
    managementFee?: null,
    rebate: number,
    cleanShare: string,
    noMin: number,
    minimumInitialInvestment: number,
    minimumAdditionalInvestment: number,
    income: number,
    performanceFee: string,
    complexity: boolean
    currency: string
}

export const InterestData = (props: IInterestData) =>
{
    return(
        <table style={{marginTop: "1em"}}>
            <tbody>
                <tr>
                    <td>
                        <strong>Comisión de gestión</strong>
                    </td>
                    <td>{props.managementFee}%</td>
                </tr>
                <tr>
                    <td>
                        <strong>Comisión de éxito</strong>
                    </td>
                    <td>{props.performanceFee !== "-" ? props.performanceFee + "%": props.performanceFee}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Producto Complejo</strong>
                    </td>
                    <td>{props.complexity ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Gastos corrientes (OGC)</strong>
                    </td>
                    <td>{props.ogc}%</td>
                </tr>
                <tr>
                    <td>
                        <strong>Retrocesión</strong>
                    </td>
                    <td>{props.rebate > 0 ? `${props.rebate}%` : '-'}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Inversión inicial mínima</strong>
                    </td>
                    
                    <td>
                        {CustomCurrencyFormat(props.minimumInitialInvestment, props.currency)}
                    </td>
                </tr>
                <tr>
                    <td>
                        <strong>Aportación adicional mínima</strong>
                    </td>
                    <td>
                        {CustomCurrencyFormat(props.minimumAdditionalInvestment, props.currency)}
                    </td>
                </tr>
                <tr>
                    <td>
                        <TooltipHost className="ironia-tooltip" content='Esta columna refleja la aplicación del mínimo de manera genérica para la clase del fondo. Puede que en una orden concreta si se aplique.'>
                            <strong>Aplica mínimo <InfoIcon /></strong>
                        </TooltipHost>
                    </td>
                    <td>{props.noMin ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Clase limpia</strong>
                    </td>
                    <td>{props.cleanShare ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Dividendos</strong>
                    </td>
                    <td>{props.income ? 'Si' : 'No'}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Días de liquidación en compras</strong>
                    </td>
                    <td>D + {props.liquidationDaysOnBuys}</td>
                </tr>
                <tr>
                    <td>
                        <strong>Días de liquidación en ventas</strong>
                    </td>
                    <td>D + {props.liquidationDaysOnSells}</td>
                </tr>
            </tbody>
        </table>
    );
};